import { render, staticRenderFns } from "./DuplicateGroupCardList.vue?vue&type=template&id=c1ff5c6a&scoped=true&"
import script from "./DuplicateGroupCardList.vue?vue&type=script&lang=js&"
export * from "./DuplicateGroupCardList.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateGroupCardList.vue?vue&type=style&index=0&id=c1ff5c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ff5c6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
